<template>
<div id="breadcrumb">
  <router-link v-if="$route.path !== '/'" to="/">
    <Icon v-if="dashboard.icon" :type="dashboard.icon" class="icon" />{{ dashboard.name }}
  </router-link>
  <transition-group name="breadcrumb">
    <span v-for="elem in breadcrumb" :key="elem.path">
      <span v-if="$route.path !== '/'" class="separator">/</span>
      <Icon v-if="elem.icon" :type="elem.icon" class="icon" />{{ elem.name }}
    </span>
  </transition-group>
  <span class="separator" style="font-size: 14px;">&nbsp;&nbsp;&nbsp;
    {{userInfo.institution&&userInfo.institution.name?userInfo.institution.name +
        (userInfo.institution&&userInfo.institution.subordinate&&userInfo.institution.subordinate.length>0? "-" + userInfo.institution.subordinate:''):''}}
  </span>
  <span class="separator" style="font-size: 14px;">{{userInfo.institution&&userInfo.institution.doctor?userInfo.institution.doctor:''}}</span>

</div>
</template>
<script>
import hideRoutes from "@/router/hide_routers"
export default {
  name: "IBreadcrumb",
  data: () => ({
    dashboard: "",
    breadcrumb: [],
    ishow:false,
    userInfo : null,
  }),
  watch: {
    // 侦听路由变化
    $route() {
      this.handleBreadcrumb();
    }
  },
  created() {
    this.userInfo = this.$userSession.getUserInfo();
  },
  mounted() {
    this.handleBreadcrumb();
  },
  methods: {
    handleBreadcrumb() {
      const menu = this.$store.state.menus.menu; // 获取菜单(主菜单和子菜单)
      if (!menu) {
        return false;
      }
      menu.find(item=>{
        if (item.flag==="REGISTRATION"){
         return this.ishow=true
        }
        this.ishow=false
      })
      const thisPath = this.$route.path; // 当前菜单路径
      const mainPath = `/${thisPath.substr(1,thisPath.length-1)}`; // 主菜单路径
      let curMenu = [];
        menu.forEach(name => {
        if (name["path"] === mainPath){
          curMenu.push(name)
        }
        if (name["children"]){
          for (let i =0; i< name["children"].length; i++){
            if (name["children"][i]["path"]=== mainPath) {
              curMenu.push(name)
              curMenu.push(name["children"][i]);
            }
            if (name["children"][i]["children"]){
              for (let j =0; j< name["children"][i]["children"].length; j++){
                if (name["children"][i]["children"][j]["path"]=== mainPath) {
                  curMenu.push(name)
                  curMenu.push(name["children"][i]["children"][j]);
                }
              }
            }
          }
        }
      }); // 获取当前菜单(主菜单和子菜单)
      const hideMenu = hideRoutes.filter(item => item["path"] === mainPath)[0];
      const breadcrumb = [];
      if (curMenu.length > 0){
          for (const item of curMenu) {
              breadcrumb.push({
                name: item["name"],
                icon: item["icon"],
                path: item["path"]
              });
          }
      } else if (hideMenu) {
        breadcrumb.push({
          name: hideMenu["alias"],
          icon: hideMenu["icon"],
          path: hideMenu["path"]
        });
        const childMenu = hideMenu["children"];
        if (childMenu) {
          for (const item of childMenu) {
            if (item["path"] === thisPath) {
              breadcrumb.push({
                name: item["name"],
                icon: item["icon"],
                path: item["path"]
              });
            }
          }
        }
      }
      this.dashboard = menu[0];
      this.breadcrumb =breadcrumb;

      // 更新页面 title 元素内容
      this.$store.commit("TITLE", '孤独症测评系统');
    },
  }
};
</script>
<style lang="postcss" scoped>
#breadcrumb {
  color: #ccc;
  font-size: 12px;
  line-height: 24px;
  margin-top: 18px;
  & .separator {
    margin: 0 8px;
  }
  & .icon {
    margin: 0 4px 2px 0;
  }
  & span {
    display: inline-block;
  }

  /* breadcrumb transition */
  & .breadcrumb-enter-active,
  & .breadcrumb-leave-active {
    transition: all 0.5s;
  }

  & .breadcrumb-enter,
  & .breadcrumb-leave-active {
    opacity: 0;
    transform: translateX(20px);
  }

  & .breadcrumb-move {
    transition: all 0.5s;
  }

  & .breadcrumb-leave-active {
    position: absolute;
  }
  & .select{
  margin-left: 60px;
    }
}
</style>
